import { render, staticRenderFns } from "./EquipamentoAcoes.vue?vue&type=template&id=1d8a4cbe&"
import script from "./EquipamentoAcoes.vue?vue&type=script&lang=js&"
export * from "./EquipamentoAcoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports